function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
/* eslint-disable no-param-reassign */
import React from 'react';
import { randomNum, LStorage } from "../../utils";
var timer = null;
var ACTIVITY_STOCK_COUNT = 'activity_stock_count';
var ACTIVITY_COUNT_EXPIRES = 'activity_count_expires';
// 获取随机计时时间
var getTimeoutTime = function getTimeoutTime(countStock) {
  var num = 100000;
  if (countStock >= 100) {
    num = randomNum(1, 3);
  } else if (50 <= countStock && countStock < 100) {
    num = randomNum(2, 5);
  } else if (10 < countStock && countStock < 50) {
    num = randomNum(3, 6);
  } else if (1 < countStock && countStock <= 10) {
    num = randomNum(2, 5);
  }
  return num;
};
var MockInventory = /*#__PURE__*/function (_React$Component) {
  _inherits(MockInventory, _React$Component);
  var _super = _createSuper(MockInventory);
  function MockInventory(props) {
    var _this;
    _classCallCheck(this, MockInventory);
    _this = _super.call(this, props);
    _this.state = {
      stockCount: 0
    };
    return _this;
  }
  _createClass(MockInventory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        activityId = _this$props.activityId,
        countStock = _this$props.countStock;
      var stock = countStock;
      var countExpires = LStorage.get(ACTIVITY_COUNT_EXPIRES) || 0;
      if (new Date().valueOf() >= countExpires) {
        LStorage.remove(ACTIVITY_STOCK_COUNT);
        LStorage.remove(ACTIVITY_COUNT_EXPIRES);
      } else {
        var activityCountList = LStorage.get(ACTIVITY_STOCK_COUNT) || [];
        if (!!activityCountList && activityCountList.length) {
          activityCountList.forEach(function (item) {
            if (item.activityId === activityId) {
              // 获取缓存中的 数量
              stock = item.countStock;
            }
          });
        } else {
          stock = countStock;
        }
      }
      this.resetStockCount(stock);
    }

    // 重置库存及库存倒计时
  }, {
    key: "resetStockCount",
    value: function resetStockCount(stock) {
      var _this2 = this;
      this.setState({
        stockCount: stock
      }, function () {
        var timeOutTime = getTimeoutTime(stock);
        _this2.loopSetTimeOut(stock, timeOutTime);
      });
    }
    // 间隔动态time秒执行下赋值
  }, {
    key: "loopSetTimeOut",
    value: function loopSetTimeOut(stock, timeOutTime) {
      var _this3 = this;
      if (stock > 0) this.props.onChangeQuotaNum && this.props.onChangeQuotaNum(this.props.countStock - stock);
      timer && clearTimeout(timer);
      timer = setTimeout(function () {
        stock -= 1;
        _this3.resetStockCount(stock);
        if (stock > 0) _this3.getLsDatas(stock);
        _this3.props.onChangeQuotaNum && _this3.props.onChangeQuotaNum(_this3.props.countStock - stock);
      }, timeOutTime * 1000);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.countStock !== this.props.countStock) {
        this.resetStockCount(nextProps.countStock);
      }
    }
    // 获取localStrong库存
  }, {
    key: "getLsDatas",
    value: function getLsDatas(countStock) {
      var activityId = this.props.activityId;
      // 1.先获取该活动id下对应的本地缓存 activity_stock_count，本地缓存没有，
      // 2.则再获取 虚拟的数量 stockCount
      var activityCountList = LStorage.get(ACTIVITY_STOCK_COUNT) || [];
      if (!!activityCountList && activityCountList.length) {
        activityCountList.forEach(function (item) {
          if (item.activityId === activityId) {
            // 获取缓存中的 数量
            item.countStock = countStock;
          }
        });
      }
      var findIndex = !!activityCountList && activityCountList.findIndex(function (item) {
        return item.activityId === activityId;
      });
      if (findIndex === -1) {
        activityCountList.push({
          activityId: activityId,
          countStock: countStock
        });
      }
      var expires = new Date(new Date(new Date().toLocaleDateString()).valueOf() * 1 + 24 * 60 * 60 * 1000 - 1);
      LStorage.set(ACTIVITY_STOCK_COUNT, activityCountList);
      LStorage.set(ACTIVITY_COUNT_EXPIRES, expires.valueOf());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.stockCount);
    }
  }]);
  return MockInventory;
}(React.Component);
export { MockInventory as default };